import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import Vue from 'vue'
import App from './App'
import api from './request/api.js'
import util from './common/util'
Vue.config.productionTip = false

App.mpType = 'app'
Vue.prototype.$http=api;
Vue.prototype.$util = util;

const app = new Vue({
    ...App
})
app.$mount()